<template>
    <div>
        <div>
            <h1 class="mb-3">
                Sign in
            </h1>

            <div class="row">
                <div class="col-md-4 col-xs-12">
                    <form>
                        <div class="form-group">
                            <label for="email">E-mail</label>
                            <input
                                id="email"
                                v-model="email"
                                type="email"
                                class="form-control"
                            >
                        </div>

                        <div class="form-group">
                            <label for="password">Password</label>
                            <input
                                id="password"
                                v-model="password"
                                class="form-control"
                                type="password"
                            >
                        </div>
                    </form>

                    <button
                        class="btn btn-primary"
                        @click="peformSignIn"
                    >
                        Sign in
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import userService from '../services/user.service';

export default {
    name: 'Login',

    data() {
        return {
            email: '',
            password: '',
        };
    },

    methods: {
        async peformSignIn() {
            await userService.login(this.email, this.password).then((response) => {
                this.$store.state.accessToken = response.data;
                localStorage.setItem('accessToken', JSON.stringify(response.data));

                axios.defaults.headers.common = {
                    Authorization: `Bearer ${response.data.token}`,
                };

                this.$router.push({
                    name: 'studies',
                });
            }).catch((error) => {
                console.error(error);

                this.$toastr.e('The e-mail password combination is incorrect.');
            });
        },
    },
};
</script>

<style scoped>

</style>
